import {FormField, RequiredFormField} from "../../../../validation/FormField";
import FormValidation from "../../../../validation/FormValidation";
import {none, option} from "ts-option";
import {ValidationResult} from "../../../../validation/ValidationResult";
import BaseFormController from "../../../../validation/BaseFormController";
import FormValidators from "../../../../validation/FormValidators";
import DictionaryItem from "../../../../model/dictionary/DictionaryItem";

const uuidv4 = require("uuid/v4");

/**
 * Dictionary item form data.
 */
export default class DictionarySortableItemForm extends BaseFormController<DictionarySortableItemForm> {
	constructor(formId: string,
		public readonly name: RequiredFormField<string>) {
		super(name, formId);
	}

	static createDictionarySortableItemForm({name = none}) {
		return new DictionarySortableItemForm(
			uuidv4(),
			RequiredFormField.create<string>(name, "Item name is required", [
				FormValidators.nonEmptyString("Item name is required")
			])
		)
	}

	public static createEmpty(): DictionarySortableItemForm {
		return this.createDictionarySortableItemForm({});
	}

	static createFromItem(item: DictionaryItem) {
		return DictionarySortableItemForm.createDictionarySortableItemForm({
			name: option(item.name)
		});
	}

	validate(): DictionarySortableItemForm {
		return FormValidation.validateForm<DictionarySortableItemForm>(this, (form, config) => form.copy(config));
	}

	onValid(onValid: (item: DictionaryItem) => void,
		onInvalid: () => void): ValidationResult<DictionaryItem> {
		return FormValidation.validateFields(
			[this.name],
			() => {
				return new DictionaryItem(uuidv4, this.name.getValue());
			}).onSuccess(item => onValid(item)).onFailure(() => onInvalid());
	}

	copy({
		name = this.name
	}): DictionarySortableItemForm {
		return new DictionarySortableItemForm(this.formId, name)
	}

	fields(): Array<FormField<any>> {
		return [this.name];
	}
}
